// src/util/uploadFile.ts

import imageCompression from "browser-image-compression";
import customFetch from "./config/axiosConfig";

export async function uploadFile(file: File): Promise<string> {
  let fileToUpload = file;
  const MAX_FILE_SIZE_MB = 90;

  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    throw new Error(`File size should be less than ${MAX_FILE_SIZE_MB}MB`);
  }

  // Allowed file types
  const allowedTypes = [
    "image/",
    "video/",
    "application/pdf",

    // Word
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

    // Excel
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

    // CSV
    "text/csv",
    "application/csv",

    // Text
    "text/plain",

    // PowerPoint
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  const isAllowed = allowedTypes.some((type) =>
    file.type.startsWith(type)
  );

  if (!isAllowed) {
    throw new Error("Unsupported file type.");
  }

  const isImage = file.type.startsWith("image/");

  // Compress images larger than 70MB
  if (isImage) {
    try {
      const fileSizeMB = file.size / (1024 * 1024);

      if (fileSizeMB > 70) {
        fileToUpload = await imageCompression(file, {
          maxSizeMB: 70,
          maxWidthOrHeight: 3840,
          useWebWorker: true,
          fileType: file.type,
        });
      }
    } catch (err) {
      console.error("Image compression error:", err);
      throw new Error("Image compression failed.");
    }
  }

  const formData = new FormData();
  formData.append("file", fileToUpload);
  formData.append("folder", "");

  try {
    const res = await customFetch.post(
      "/api/file/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const data = res.data;

    if (!data?.data) {
      throw new Error("No file URL returned from server.");
    }

    return data.data;
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message ||
      error?.message ||
      "Upload failed"
    );
  }
}
